import React, {useEffect, useState} from 'react'
import {Redirect, useParams} from 'react-router-dom'
import * as Yup from 'yup'
import {useFormik} from 'formik'
import {editOrganization, getOrganization} from '../../auth/redux/OrganizationCRUD'
import {FORM_STATUSES, getUrlPrefix} from '../../utils'
import { OrganizationModel } from '../../auth/models/OrganizationModel'
import { AxiosResponse } from 'axios'
import { useSelector, shallowEqual } from 'react-redux'
import { RootState } from '../../../../setup'

const organizationSchema = Yup.object().shape({
  name: Yup.string().required('Name is required'),
})

const EditOrganization: React.FC = () => {
  const initialValues = {name: ''};
  const [loading, setLoading] = useState(false)
  const {id}: any = useParams();  
  const [data, setData] = useState<OrganizationModel>();
  const [dataError, setDataError] = useState<DataError>();

  const formik = useFormik<any>({
    initialValues,
    validationSchema: organizationSchema,
    onSubmit: (values, {setStatus}) => {
      setLoading(true);
      editOrganization(id, values.name).then(({data: {id}}) => {
        setLoading(false);
        setStatus({state: FORM_STATUSES.SUCCESS, response: {id}});
      }).catch(() => {
        setLoading(false);
        setStatus({state: FORM_STATUSES.FAILURE, response: {error: 'Server Error!'}});
      });
    },
  });
  
  useEffect(() => {
    getOrganization(parseInt(id)).then((result: AxiosResponse) => {
      formik.setFieldValue('name', result.data.name);
      setData(result.data);
    }).catch(e => setDataError({error: "Server Error! Cannot fetch data!"}));
  }, []);

  const isMobile = useSelector<RootState>(({auth}) => auth.isMobile, shallowEqual)
  const urlPrefix = getUrlPrefix(isMobile);

  if (dataError || data == null) {
    return (
      <div className='card mb-5 mb-xl-10'>
        <div
          className='card-header border-0 cursor-pointer'
          role='button'
          data-bs-toggle='collapse'
          data-bs-target='#kt_account_profile_details'
          aria-expanded='true'
          aria-controls='kt_account_profile_details'
        >
          {dataError ? (
            <div>
              <br />
                <div className='mb-lg-15 alert alert-danger d-flex flex-column-fluid flex-center'>
                  <div className='alert-text font-weight-bold'>{dataError.error}</div>
                </div>
                </div>
          ) : (
            <div>
              <br />
              <span>Loading... </span> <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
           </div>
        )}
        </div>
      </div>
      );
  }

  return (
    <div className='card mb-5 mb-xl-10'>
      <div
        className='card-header border-0 cursor-pointer'
        role='button'
        data-bs-toggle='collapse'
        data-bs-target='#kt_edit_organization'
        aria-expanded='true'
        aria-controls='kt_edit_organization'
      >
        <div className='card-title m-0'>
          <h3 className='fw-bolder m-0'>Edit Organization</h3>
        </div>
      </div>

      {formik.status && formik.status.state == FORM_STATUSES.SUCCESS ? (
        <Redirect to={urlPrefix + '/core/org/manage'} />
      ) : null}

      {formik.status && formik.status.state == FORM_STATUSES.FAILURE ? (
        <div className='mb-lg-15 alert-danger'>
            <div className='alert-text font-weight-bold'>{formik.status.response?.error}</div>
        </div>
      ) : null}

      <div id='kt_create_organization' className='collapse show'>
        <form onSubmit={formik.handleSubmit} noValidate className='form'>
          <div className='card-body border-top p-9'>

            <div className='row mb-6'>
              <label className='col-lg-4 col-form-label required fw-bold fs-6'>Organization Name</label>
              <div className='col-lg-8'>
                <div className='row'>
                  <div className='col-lg-6 fv-row'>
                    <input
                      type='text'
                      className='form-control form-control-lg form-control-solid mb-3 mb-lg-0'
                      placeholder='Organization name'
                      {...formik.getFieldProps('name')}
                    />
                    {formik.touched.name && formik.errors.name && (
                      <div className='fv-plugins-message-container'>
                        <div className='fv-help-block'>{formik.errors.name}</div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>              

          <div className='card-footer d-flex justify-content-end py-6 px-9'>
            <button type='submit' className='btn btn-primary' disabled={loading}>
              {!loading && 'Save Changes'}
              {loading && (
                <span className='indicator-progress' style={{display: 'block'}}>
                  Please wait...{' '}
                  <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                </span>
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  )
}

export {EditOrganization}
